export enum BusyStatusEnum {
    Free = 0,
    Tentative = 1,
    Busy = 2,
    OutOfOffice = 3
}
